import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const Homepage = lazy(() => import('./components/homepage'));
const SurveyList = lazy(() => import('./components/survey-list/survey-list'));
const SurveyView = lazy(() => import('./components/survey-view/survey-view'));
const CoreQuestionView = lazy(
    () => import('./components/core-question-view/core-question-view')
);
const SurveyProof = lazy(
    () => import('./components/survey-proof/survey-proof')
);
const AuthGroupView = lazy(
    () => import('./components/auth-group-view/auth-group-view')
);
const TeamManagerView = lazy(
    () => import('./components/team-manager-view/team-manager-view')
);
const CacheManagerView = lazy(
    () => import('./components/cache-manager-view/cache-manager-view')
);

const ReportingSurveyView = lazy(
    () =>
        import(
            './components/reportings/reporting-survey-view/reporting-survey-view'
        )
);
const ReportingView = lazy(
    () => import('./components/reportings/reporting-view/reporting-view')
);
const ReportingCoreQuestionView = lazy(
    () =>
        import(
            './components/reportings/reporting-core-question-view/reporting-core-question-view'
        )
);
const NotFound = lazy(() => import('./components/not-found/not-found'));
const LogoutPage = lazy(() => import('./components/logout-page'));

export function App() {
    return (
        <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/teams/:teamId" element={<SurveyList />} />
            <Route path="/surveys/:surveyId" element={<SurveyView />} />
            <Route
                path="/surveys/:surveyId/preview"
                element={<SurveyProof />}
            />
            <Route path="/core-questions" element={<CoreQuestionView />} />
            <Route path="/auth-groups" element={<AuthGroupView />} />
            <Route path="/teams" element={<TeamManagerView />} />
            <Route path="/clear-caches" element={<CacheManagerView />} />
            <Route path="/reporting/general" element={<ReportingView />} />
            <Route
                path="/reporting/surveys/:surveyId"
                element={<ReportingSurveyView />}
            />
            <Route
                path="/reporting/core-questions"
                element={<ReportingCoreQuestionView />}
            />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default App;
